import React from 'react';

import { ReactComponent as TrashIcon } from 'assets/trash.svg';
import { selectIsAuthed } from 'store/customer/customer.selectors';
import { useAppSelector } from 'store/store';

import RemoveItemModal from './RemoveItemModal/RemoveItemModal';
import { REMOVE_OPTIONS_TEST_ID } from './RemoveOptions.test-ids';

import styles from './RemoveOptions.module.scss';

const RemoveOptions: React.FC = () => {
  const isAuthed = useAppSelector(selectIsAuthed);
  const [isModalOpen, setIsModalOpen] = React.useState(false);

  if (!isAuthed) return null;

  return (
    <div className={styles.removeItemWrapper}>
      <button
        className={styles.removeItemButton}
        onClick={() => setIsModalOpen(!isModalOpen)}
        data-testid={REMOVE_OPTIONS_TEST_ID}
      >
        <TrashIcon className={styles.removeItemIcon} />
        Remove from list
      </button>
      <RemoveItemModal isOpen={isModalOpen} handleClose={() => setIsModalOpen(false)} />
    </div>
  );
};

export default RemoveOptions;
